/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Users_Selected_CountInputs */

const cs_users_selected_count = /** @type {(inputs: Users_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vybráno: ${i?.count}`)
};

const en_users_selected_count = /** @type {(inputs: Users_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selected: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Selected: {count}" |
*
* @param {Users_Selected_CountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const users_selected_count = /** @type {((inputs: Users_Selected_CountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Selected_CountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_selected_count(inputs)
	return cs_users_selected_count(inputs)
});